module.exports = "<div class=\"body-spinner-container\" data-slnm-ihg=\"spinnerChangeReservationSID\">\n  <div class=\"loading-spinner\" *ngIf=\"showSpinner\">\n    <div></div>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/spinner/spinner.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/spinner/spinner.component.html
// module chunks = 0